import fromUnixTime from "date-fns/fromUnixTime";

import DescriptionDetails from "components/DescriptionDetails";
import FormFieldViewText from "components/FormFields/ViewText";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";
import { TemplateVersion } from "types/generated";
import { formatDate } from "utils/date";

import DeprecatedVersionBadge from "../Template/Versions/DeprecatedVersionBadge";

type VersionDetailsProps = {
  item: TemplateVersion;
};

const VersionDetailsDrawer = createDrawer(({ item }: VersionDetailsProps) => {
  const onOpenFullDescription = useShowFullDescriptionWithBackArrow(item.instructions);

  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Version details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <FormFieldViewText label="Version identifier" value={item.version} />

        {item.deprecatedAt && (
          <>
            <Box
              margin="large 0 0 0"
              shrink="0"
              style={{ alignSelf: "flex-start", width: "fit-content" }}
            >
              <DeprecatedVersionBadge deprecatedAt={item.deprecatedAt} />
            </Box>
            <FormFieldViewText
              label="Deprecated at"
              value={formatDate({ date: fromUnixTime(item.deprecatedAt) })}
            />
            {item.deprecationNote ? (
              <FormFieldViewText
                label="Deprecation note"
                value={item.deprecationNote}
                noTextEllipsis
              />
            ) : null}
          </>
        )}

        <DescriptionDetails
          description={item.instructions}
          onOpenFullDescription={onOpenFullDescription}
        />
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showVersionDetailsDrawer = createDrawerTrigger(VersionDetailsDrawer);
